import { animated, config, useSpring } from '@react-spring/web';
import { memo } from 'react';

import { CircleAlertIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { type FileStatusIconSize, fileStatusIcon, getFileStatusIconGlyphSize } from '../fileStatusIconSize';

export type FileStatusIconErroredProps = {
  size?: FileStatusIconSize;
};

export const FileStatusIconErrored = memo(({ size = 'default' }: FileStatusIconErroredProps) => {
  const { container } = fileStatusIcon({ size });
  const glyphSize = getFileStatusIconGlyphSize(size);
  const [props] = useSpring(
    () => ({
      config: config.wobbly,
      from: { scale: 0 },
      to: { scale: 1 },
    }),
    [],
  );

  return (
    <div
      aria-hidden
      className={cn('flex items-center justify-center rounded-full ads:bg-error-subtle bg-flash-4', container())}
    >
      <animated.div className="flex items-center justify-center" style={props}>
        <CircleAlertIcon className="ads:text-icon-error text-ember-11" size={glyphSize} />
      </animated.div>
    </div>
  );
});

FileStatusIconErrored.displayName = 'FileStatusIconErrored';
